import { render, staticRenderFns } from "./_details.vue?vue&type=template&id=bb81a8e4&"
import script from "./_details.vue?vue&type=script&lang=js&"
export * from "./_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb81a8e4')) {
      api.createRecord('bb81a8e4', component.options)
    } else {
      api.reload('bb81a8e4', component.options)
    }
    module.hot.accept("./_details.vue?vue&type=template&id=bb81a8e4&", function () {
      api.rerender('bb81a8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/document-package/views/_details.vue"
export default component.exports